import React, { useEffect } from "react";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

import {
  StyledText,
  MainHolder,
  Children,
  Body,
} from "../../../components/common/basic";
import { BackButton, Box } from "../../../components/common";
import ProductItemList from "../../../components/common/ProductItemList";
import useSpeedShopping from "./hooks/useSpeedShopping";
import SpeedShoppingTimer from "./components/SpeedShoppingTimer";
import { InfoBox } from "../../../components/svgs";
import CartAlertModal from "../../../components/loyalty/cartAlertModal";

const SpeedShoppingHome = () => {
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "SpeedShoppingPromoStart",
        firebase_screen_class: "SpeedShoppingPromoStart",
      })
    );
  }, []);
  const {
    background,
    history,
    items,
    timerFunc,
    addItemToCart,
    decreaseCartItem,
    cartQuantity,
    setShowLimitDialog,
    showLimitDialog,
    showDeleteConfirmModal,
    confirmDeleteItem,
    setShowDeleteConfirmModal,
  } = useSpeedShopping();

  useEffect(() => {
    if (timerFunc) {
      timerFunc.initializeTimer();
      if (timerFunc?.isTime) {
        history.push("/speedshopping/cart");
      }
    }
  }, [timerFunc]);

  const { minute, second, isTime } = timerFunc || {};

  return (
    <>
      {showLimitDialog && (
        <LimitDialog setShowLimitDialog={setShowLimitDialog} />
      )}
      <MainHolder>
        <Children>
          {
            showDeleteConfirmModal &&
            <CartAlertModal
              onOkClick={confirmDeleteItem}
              hideModal={() => setShowDeleteConfirmModal(false)}
              background={background}
            />
          }

          <SpeedShoppingTimer
            timeRemaining={{
              minute,
              second,
              isTime,
            }}
            history={history}
            quantity={cartQuantity}
            background='#EE2737'
          />
          <BackButton onClick={() => history.goBack()} />
          <Body>
            <div
              style={{
                boxSizing: "border-box",
                padding: "80px 15px 10px 15px",
              }}
            >
              <StyledText
                size={24}
                style={{ fontFamily: "MTNMedium", margin: "0 0 24px 0" }}
              >
                Branded vouchers to shop
              </StyledText>

              <ProductItemList
                background={background}
                items={items}
                addToCart={addItemToCart}
                decreaseCartItem={decreaseCartItem}
                setShowLimitDialog={setShowLimitDialog}
                cartQuantity={cartQuantity}
              />
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const LimitDialog = ({ setShowLimitDialog }) => {
  return (
    <Dialog
      title='Shopping limit reached'
      setShowLimitDialog={setShowLimitDialog}
      onClose={() => {
        setShowLimitDialog(false);
      }}
      description={
        <StyledText
          style={{
            fontSize: "14px",
            textAlign: "center",
            fontFamily: "MTNRegular",
          }}
        >
          Sorry. Cost of vouchers in your cart cannot exceed GHS 500 limit.
        </StyledText>
      }
    />
  );
};

const Dialog = ({ title, setShowLimitDialog, onClose, description }) => {
  return (
    <Box
      style={{
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 99,
      }}
    >
      <Box
        style={{
          opacity: 1,
          backgroundColor: "white",
          marginLeft: 15,
          marginRight: 15,
          borderRadius: 30,
          padding: "10px 15px 0 15px",
        }}
      >
        <StyledText style={{ fontSize: 22, textAlign: "center" }}>
          {title}
        </StyledText>
        <div style={{ textAlign: "center" }}>
          <InfoBox />
        </div>
        {description}
        <Box
          onClick={() => {
            setShowLimitDialog(false);
          }}
          style={{
            margin: 25,
            marginBottom: 50,
            paddingTop: 2,
            paddingBottom: 2,
            borderRadius: 30,
            backgroundColor: "#E31C79",
            cursor: "pointer",
          }}
        >
          <StyledText
            style={{
              textAlign: "center",
              color: "white",
            }}
          >
            Ok
          </StyledText>
        </Box>
      </Box>
    </Box>
  );
};

export default SpeedShoppingHome;
